<section *ngIf="!isLoading && !isError">
	<div class="zk-mb-4 md:zk-hidden">
		<h1 class="zk-pb-1 zk-text-1">
			{{ 'MY_ACCOUNT_MENU.SESSIONS_ONSITE.TITLE' | translate }}
		</h1>

		<span class="zk-text-3">
			{{ 'MY_ACCOUNT_MENU.SESSIONS_ONSITE.DESCRIPTION' | translate }}
		</span>
	</div>
	<div class="zk-mb-2">
		<app-address-card
			*ngFor="let address of addresses; let i = index"
			[address]="address"
			[index]="i + 1"
			(removedAddress)="onRemovedAddress($event)"
		>
		</app-address-card>
	</div>
	<div
		*ngIf="showNewAddressButton()"
		class="zk-flex zk-justify-center zk-items-center new-address__container"
	>
		<freud-button color="secondary" (click)="goToAddressForm()">
			{{ 'MY_ACCOUNT.ONSITE_SESSIONS.BUTTONS.NEW' | translate }}
		</freud-button>
	</div>
</section>

<section *ngIf="!isLoading && isError">
	<span class="zk-text-3">
		{{ 'MY_ACCOUNT.ONSITE_SESSIONS.ERRORS.FETCH_ADDRESSES' | translate }}
	</span>
</section>

<section *ngIf="isLoading" class="zk-flex zk-justify-center zk-py-5">
	<freud-loader size="sm" [bgColor]="false"></freud-loader>
</section>
